export default __webpack_public_path__ + "static/media/fauna-docs-2018-p2.462980c6.png";